import { render, staticRenderFns } from "./activity-qr-sign.vue?vue&type=template&id=5d6ff356&scoped=true&"
import script from "./activity-qr-sign.vue?vue&type=script&lang=js&"
export * from "./activity-qr-sign.vue?vue&type=script&lang=js&"
import style0 from "./activity-qr-sign.vue?vue&type=style&index=0&id=5d6ff356&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ff356",
  null
  
)

export default component.exports